import DoctorList from './DoctorList'
import Profile from './Profile'
import Auth from './Auth'

export default {
  doctorList: DoctorList,
  profile: Profile,
  auth: Auth
}
